const BhVampQuestionMark = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1ZM5.375 4.25C5.30596 4.25 5.25 4.30596 5.25 4.375V4.625C5.25 4.83211 5.08211 5 4.875 5C4.66789 5 4.5 4.83211 4.5 4.625V4.375C4.5 3.89175 4.89175 3.5 5.375 3.5H6.625C7.10825 3.5 7.5 3.89175 7.5 4.375V4.98241C7.5 5.27497 7.35379 5.54817 7.11036 5.71045L6.43066 6.16359C6.39589 6.18677 6.375 6.2258 6.375 6.26759V6.625C6.375 6.83211 6.20711 7 6 7C5.79289 7 5.625 6.83211 5.625 6.625V6.26759C5.625 5.97503 5.77121 5.70183 6.01464 5.53955L6.69434 5.08641C6.72911 5.06323 6.75 5.0242 6.75 4.98241V4.375C6.75 4.30596 6.69404 4.25 6.625 4.25H5.375ZM6 7.5C5.72386 7.5 5.5 7.72386 5.5 8C5.5 8.27614 5.72386 8.5 6 8.5C6.27614 8.5 6.5 8.27614 6.5 8C6.5 7.72386 6.27614 7.5 6 7.5Z"
      fill="currentColor"
    />
  </svg>
)

export default BhVampQuestionMark
